import fetchJSON from '@api/api_helper';

const getUrl = (assetKey) => `/api/v4/assets/${assetKey}`;

export const get = (assetKey, options) => (
  fetchJSON(getUrl(assetKey), options)
    .then(({ data }) => data)
    .catch(async (response) => { throw (await response.json()); })
);

const createAssets = (options) => {
  const url = options.url;
  const appendedOptions = {
    method: 'POST',
    body: {
      section_key: options.section_key,
      data: options.data
    },
    context: options.context
  };

  return fetchJSON(url, appendedOptions);
};

export default createAssets;
